import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './TrajectoryCheck.module.scss';

interface Props {
  trajectoryRate?: number;
  trajectoryMax?: number;
}

const TrajectoryCheck: React.FC<Props> = ({ trajectoryRate, trajectoryMax }) => {
  const getTrajectoryRate = () => {
    if (trajectoryRate === undefined || trajectoryRate === null) {
      return (
        <div className={styles.redText}>
          <FormattedMessage id="dataManagement.dataQuality.dataConsistency.trajectoryCheck.trajectoryRateFailure" />
        </div>
      );
    }

    return (
      <div>
        <span className={trajectoryRate > 1 ? styles.greenText : styles.redText}>
          {trajectoryRate.toFixed(1)}
        </span>
        <FormattedMessage id="dataManagement.dataQuality.dataConsistency.trajectoryCheck.trajectoryRate" />
      </div>
    );
  };

  const getTrajectoryMax = () => {
    if (trajectoryMax === undefined || trajectoryMax === null) {
      return (
        <div className={styles.redText}>
          <FormattedMessage id="dataManagement.dataQuality.dataConsistency.trajectoryCheck.trajectoryMaxFailure" />
        </div>
      );
    }

    return (
      <div>
        <span
          className={
            trajectoryMax < 100
              ? styles.greenText
              : trajectoryMax < 300
              ? styles.yellowText
              : styles.redText
          }
        >
          {trajectoryMax.toFixed(1)}
        </span>
        <FormattedMessage id="dataManagement.dataQuality.dataConsistency.trajectoryCheck.trajectoryMax" />
      </div>
    );
  };

  return (
    <div>
      <div className={styles.title}>
        <FormattedMessage id="dataManagement.dataQuality.dataConsistency.trajectoryCheck.title" />
      </div>
      {getTrajectoryRate()}
      {getTrajectoryMax()}
    </div>
  );
};

export default TrajectoryCheck;
